import { useState } from "react";
import { KmsTypeComponent, KmsTypeHeroProps } from "@kaltura/mediaspace-shared-types";
import { useInterval } from "@kaltura/mediaspace-shared-hooks";
import { getKmsData, baseUrl } from "@kaltura/mediaspace-shared-utils";
import { ConversionStatus } from "./conversion-status/ConversionStatus";
import { ConversionError } from "./conversion-error/ConversionError";

export interface ConvertingProps extends KmsTypeHeroProps {
    onConversionEnd: () => void;
}

interface ConversionStatusProps {
    converting: boolean;
    conversionError: boolean;
    actions?: KmsTypeComponent[];
}

/**
 * media-page convertion status component -
 * checks media conversion status, and updates the page when ready
 */
export function Converting(props: ConvertingProps) {
    const { entry, onConversionEnd } = props;

    const [conversionError, setConversionError] = useState(props.conversionError ?? false);

    const [actions, setActions] = useState<KmsTypeComponent[]>(props.actions ?? []);

    const handleConversionDone = (params: ConversionStatusProps) => {
        const { converting, conversionError, actions } = params;

        // update conversion error status
        conversionError && setConversionError(conversionError);

        // replace actions on conversion error
        conversionError && setActions(actions ?? []);

        // update conversion done status
        !converting && !conversionError && onConversionEnd();
    };

    const checkConversionstatus = async () => {
        const url = baseUrl + "/default/media/check-conversion-status/id/" + entry.id;
        try {
            const params = await getKmsData(url);
            handleConversionDone(params);
        }
        catch (e: unknown) {
            console.error("Failed to check conversion status", e, { url });
        }
    };

    useInterval(checkConversionstatus, !conversionError ? 10000 : null);

    return (
        <>
            {!conversionError && <ConversionStatus {...props} />}
            {conversionError && <ConversionError {...props} actions={actions} />}
        </>
    );
}

export default Converting;
